export default {
  DAILY_DIGEST: 41,
  WEEKLY_DIGEST: 45,
  MONTHLY_DIGEST: 46,

  NEW_POST: 10,
  DAILY_COMMUNITY_ACTIVITY_SUMMARY: 40,
  HU_RESEARCH_EMAILS: 55,
};
